package com.svdsak.components.sections

import androidx.compose.runtime.Composable
import com.svdsak.style.FooterContentStyle
import com.svdsak.util.Res
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.cssRem

@Composable
fun Footer(
    modifier: Modifier = Modifier,
    breakpoint: Breakpoint
) {
    Box(
        FooterContentStyle
            .toModifier()
            .then(modifier)
    ) {
        Row(
            Modifier
                .align(Alignment.Center)
                .flexWrap(FlexWrap.Wrap)

        ) {
            SpanText(
                text = Res.COPY_RIGHT,
                Modifier
                    .color(Colors.Wheat)
                    .fontSize(if (breakpoint >= Breakpoint.MD) 1.cssRem else 0.5.cssRem)
            )
        }
        Row(
            Modifier
                .align(Alignment.BottomEnd)
                .flexWrap(FlexWrap.Wrap)

        ) {
            SpanText(
                text = Res.DEVELOPED_BY,
                Modifier.fontSize(if (breakpoint >= Breakpoint.MD) 0.8.cssRem else 0.4.cssRem)
            )
            Link(
                "https://vrajatcreations.com",
                Res.DEV_COMPANY_NAME,
                Modifier
                    .color(Colors.White)
                    .fontSize(if (breakpoint >= Breakpoint.MD) 0.8.cssRem else 0.4.cssRem),
                openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
            )
        }
    }

}